/** Indonesian language strings — V1 is Indonesian-only. */
export const t = {
  appName: "DFA — Operator Dashboard",
  // Auth
  login: "Masuk",
  email: "Email",
  password: "Kata sandi",
  logout: "Keluar",
  loginErrorTitle: "Gagal masuk",
  // Klien queue
  klienQueue: "Antrian Klien",
  scope: "Cakupan",
  refresh: "Refresh",
  newKlien: "Klien Baru",
  empty: "Belum ada klien menunggu review.",
  loading: "Memuat…",
  // Layer 4
  jumpToProblems: "jari butuh review",
  startFromHere: "Mulai dari sini",
  approveAll: "Approve semua",
  approveAllConfirm: "Untuk approve semua, ketik inisial klien",
  pattern: "Pola",
  ridge: "Sulur",
  approve: "Approve",
  reCount: "Ulang hitung",
  approved: "Disetujui",
  needsReview: "Butuh review",
  patternIs: "Pola:",
  confidence: "Keyakinan",
  // Edit
  draftSaved: "Draft tersimpan",
  secondsAgo: "detik lalu",
  conflictTitle: "Perubahan konflik",
  conflictBody: "Data ini sudah diubah orang lain. Refresh untuk melihat versi terbaru.",
  // Approve
  finalSubmitTitle: "Konfirmasi Final",
  finalSubmitBody: "Ketik inisial klien untuk submit final dan kirim ke klien.",
  typeInitials: "Ketik inisial klien (mis. RAP untuk Rizki Aditya Permana)",
  submitFinal: "Kunci & kirim ke klien",
  back: "Kembali",
  // Flag-back
  flagBack: "Flag review (Bu Emmy)",
  flagBackReason: "Alasan flag-back",
  // Disclaimer
  framingDisclaimer:
    "Hasil DFA menggambarkan POTENSI GENETIK BAWAAN — bukan kondisi anak sekarang. Stimulus & lingkungan dapat membentuk anak berbeda dari potensi bawaannya. Gap ini justru adalah materi konsultasi paling berharga.",
  framingDisclaimerShort: "Hasil = potensi bawaan, bukan kondisi sekarang",
  // Roles
  roleOwner: "Owner (Bu Emmy / DCPPI)",
  roleAgent: "Agen Franchisor",
  roleScanStation: "Stasiun Scan",
  roleSuperAdmin: "Super Admin",
  // Statuses
  statusUploaded: "Upload",
  statusStitching: "Stitching",
  statusStitched: "Tergabung",
  statusAnalyzing: "Sedang dianalisa",
  statusAnalyzed: "Terdianalisa",
  statusReadyForReview: "Siap direview",
  statusApproving: "Sedang di-approve",
  statusApproved: "Disetujui",
  statusReporting: "Sedang generate report",
  statusReported: "Report selesai",
  statusFlagged: "Di-flag Bu Emmy",
  statusVoided: "Dibatalkan",
} as const;

export type T = typeof t;

export function statusLabel(s: string): string {
  const map: Record<string, string> = {
    uploaded: t.statusUploaded,
    stitching: t.statusStitching,
    stitched: t.statusStitched,
    analyzing: t.statusAnalyzing,
    analyzed: t.statusAnalyzed,
    ready_for_review: t.statusReadyForReview,
    approving: t.statusApproving,
    approved: t.statusApproved,
    reporting: t.statusReporting,
    reported: t.statusReported,
    flagged: t.statusFlagged,
    voided: t.statusVoided,
  };
  return map[s] ?? s;
}
